import React from "react";
import PropTypes from "prop-types";
import "./style.less";

function AreaCategoryLabel({ type, area, count, selected, onClick }) {
  const typeToNameMap = {
    NON_SERVICEABLE_AREA: " Non Serviceable Areas",
    BUDDY_BLOCK: "RM Buddy Blocks",
    SERVICEABLE_AREA: "Serviceable Areas",
    WAREHOUSE_FENCE: "Warehouse fences"
  };
  const selectedClass = selected ? "selected" : "";
  let displayArea = Math.round(area / 1000000);
  displayArea =
    displayArea === 0 ? Math.round(area) + " sq. m" : displayArea + " sq. Km";
  return (
    <div
      onClick={onClick}
      className={`${type} ${selectedClass} inverted AreaCategoryLabel`}
    >
      <div className="name">{`${typeToNameMap[type]}`}</div>
      <div className="count"> {`${count}`} </div>
      <div className="area">{`${displayArea}`}</div>
    </div>
  );
}

AreaCategoryLabel.defaultProps = {};

AreaCategoryLabel.propTypes = {
  type: PropTypes.oneOf([
    "SERVICEABLE_AREA",
    "NON_SERVICEABLE_AREA",
    "BUDDY_BLOCK",
    "WAREHOUSE_FENCE"
  ]),
  areaInSqKm: PropTypes.number,
  count: PropTypes.number,
  backable: PropTypes.bool
};

export default AreaCategoryLabel;
